import {
  findCacheByKey as CfindCacheByKey,
  findCacheByKeyStartWith as CfindCacheByKeyStartWith,
  deleteCacheByKey as CdeleteCacheByKey,
  getCacheSet as CgetCacheSet,
  deleteCacheByKeyStartWith as CdeleteCacheByKeyStartWith
} from "../decorators/cache/CacheDecorator.js";
class CacheManager {
  constructor(simpleApplication) {
    this.simpleApplication = simpleApplication;
  }
  findCacheByKey(key) {
    return CfindCacheByKey(this.simpleApplication, key);
  }
  findCacheByKeyStartWith(key) {
    return CfindCacheByKeyStartWith(this.simpleApplication, key);
  }
  deleteCacheByKey(key) {
    return CdeleteCacheByKey(this.simpleApplication, key);
  }
  deleteCacheByKeyStartWith(key) {
    return CdeleteCacheByKeyStartWith(this.simpleApplication, key);
  }
  getCacheSet() {
    return CgetCacheSet(this.simpleApplication);
  }
}
export {
  CacheManager
};
//# sourceMappingURL=CacheManager.js.map
